import React from 'react';
import { useNavigate } from 'react-router-dom';
import { NavArrowLeft } from 'iconoir-react';
import { AuthenticatedLayout } from "@/components/layout/AuthenticatedLayout";

const SavedPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <AuthenticatedLayout showBottomNav={true} showNavbar={false} backgroundColor="#FBF6F1">
      <div className="w-full min-h-screen bg-[#FBF6F1] flex flex-col">
        {/* Header */}
        <div className="w-full h-14 p-4 inline-flex justify-between items-start">
          <div
            className="size-7 relative overflow-hidden cursor-pointer"
            onClick={() => navigate(-1)}
          >
            <NavArrowLeft className="h-6 w-6 text-[#1E3A3A]" />
          </div>
          <div className="justify-start text-[#1E3A3A] text-2xl font-medium font-manrope leading-7">
            Đã lưu
          </div>
          <div className="size-7 relative opacity-0 overflow-hidden">
            <NavArrowLeft className="h-6 w-6 text-[#1E3A3A]" />
          </div>
        </div>

        {/* Content */}
        <div className="w-full py-6 flex flex-col justify-start items-center gap-6">
          <div>
            <img src="/icons/no_bookmarks.svg" alt="No bookmarks" className="w-32 h-32"/>
          </div>
          <div className="self-stretch text-center justify-start text-[#6F6F6B] text-sm font-normal font-sora leading-tight">
            Hiện chưa có bookmarks nào
          </div>
        </div>
      </div>
    </AuthenticatedLayout>
  );
};

export default SavedPage;
